"use strict";

var Graphics = require('pixi.js').Graphics;
var Sprite = require('pixi.js').Sprite;
const _ = require('lodash');
const Entity = require('./Entity.js').Entity;
const Tween = require('../util/Tween.js').Tween;

export let Wall = function(options){
	Entity.call(this, options);
}

Wall.prototype = Object.create(Entity.prototype);
Wall.prototype.constructor = Wall;

Wall.prototype.update = function(dt) {

};

Wall.prototype.setOppositeWall = function(wall) {
	this.oppositeWall = wall;
}

Wall.prototype.getOppositeWall = function() {
	return this.oppositeWall;
}

Wall.prototype.setPosition = function(x, y) {
	this.graphics.x = this.x = x;
	this.graphics.y = this.y = y;
};

Wall.prototype.grow = function(pixels) {
	let y = this.y + this.direction.y * pixels;
	let x = this.x + this.direction.x * pixels;
	const end = { x, y };
	Tween.tweenPosition(this, end).start();
}

Wall.prototype.createGraphics = function() {
	// draw a shape
	let graphics = new Graphics();
	graphics.lineStyle(0, 0xFFFFFF, 0.25);
	graphics.beginFill(0x444444, 1);

	graphics.drawRoundedRect(0, 0, this.width, this.height, this.radius);
	graphics.endFill();
	graphics.x = this.x;
	graphics.y = this.y;

	graphics = new Sprite(graphics.generateTexture(false));
	graphics.anchor.set(this.anchor.x, this.anchor.y);
	return graphics;
};






/** WEBPACK FOOTER **
 ** ./~/jshint-loader!./src/entities/Wall.js
 **/